import React, { useCallback, useState, useContext } from "react";
import { Redirect, withRouter } from "react-router";
import { AuthContext } from "../../Auth";
import { auth } from "../../firebase";

import { signInWithEmailAndPassword } from "firebase/auth";

import { Expert1 } from "../../images";

import {
  SectionBanner,
  LoginBox,
  ImagUser,
  TextLink,
  FormLogin,
  LinkRegister,
  DisplayError,
} from "./auth.styles";

// const Login2 = ({ history }) => {
//   const [error, setError] = useState("");
//   const handleLogin = useCallback(
//     async (event) => {
//       event.preventDefault();
//       const { email, password } = event.target.elements;
//       setError("");
//       try {
//         await auth.signInWithEmailAndPassword(email.value, password.value);
//         history.push("/");
//       } catch (error) {
//         //alert(error);
//         setError(error.message);
//       }
//     },
//     [history]
//   );

const Login2 = ({ history }) => {
  const [error, setError] = useState("");

  const handleLogin = useCallback(
    async (event) => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      setError("");

      try {
        await signInWithEmailAndPassword(auth, email.value, password.value);
        history.push("/");
      } catch (error) {
        setError(error.message);
      }
    },
    [history],
  );

  const { currentuser } = useContext(AuthContext);
  if (currentuser) {
    return <Redirect to="/" />;
  }

  return (
    <SectionBanner>
      {error ? (
        <DisplayError>
          <span>{error}</span>
        </DisplayError>
      ) : (
        <></>
      )}
      <LoginBox>
        <ImagUser>
          <img alt="" src={Expert1} />
        </ImagUser>
        <h3>Sign In Here </h3>

        <FormLogin>
          <form onSubmit={handleLogin}>
            <input name="email" type="email" placeholder="Your Email" />
            <input
              name="password"
              type="password"
              placeholder="Your Password"
            />
            <button type="submit">Login</button>
          </form>
        </FormLogin>

        <TextLink>
          <LinkRegister color={"#ff0157"} to="/signup">
            Sign Up
          </LinkRegister>
          <LinkRegister color={"#fff"}>Forget password?</LinkRegister>
        </TextLink>
      </LoginBox>
    </SectionBanner>
  );
};

export default withRouter(Login2);
